// import logo from '../static/logo.svg'

function Footer() {
  return (
    <footer className="[ footer ] [ nav ] [ flex ]">
      <p>&copy; 2021 UXPA Seattle</p>
      <a className="[ link bold ]" href="#top">Top</a>
    </footer>
  )
}

export default Footer;